<svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
  <path
    d="M0.25 11.625V10.125H17.75V11.625H0.25ZM0.25 6.75V5.25H17.75V6.75H0.25ZM0.25 1.875V0.375H17.75V1.875H0.25Z"
    fill="var(--color-title)"
  />
</svg>
